import classNames from 'classnames';

const progressBgColors = {
  standard: 'bg-cf-gray-4',
  active: 'bg-cf-green-1',
  disabled: 'bg-cf-gray-3',
  warning: 'bg-cf-orange-1',
  error: 'bg-cf-red-1',
} as const;

export type ProgressBarVariant = keyof typeof progressBgColors;

export interface ProgressBarProps {
  variant: ProgressBarVariant;
  value: number;
  className?: string;
  lightBackground?: boolean;
}

export function ProgressBar({
  variant = 'standard',
  value = 0,
  className = 'mt-3',
  lightBackground = false,
}: ProgressBarProps): React.JSX.Element {
  const bgColor =
    variant === 'standard' && lightBackground ? 'bg-cf-light-2' : progressBgColors[variant];

  return (
    <div
      className={classNames(
        'h-2 w-full rounded-full',
        lightBackground ? 'bg-cf-gray-4' : 'bg-cf-gray-3',
        className,
      )}
    >
      <div
        style={{ width: `${value}%` }}
        className={`h-full text-center text-xs text-white ${bgColor} rounded-full`}
      />
    </div>
  );
}
